export default __webpack_public_path__ + "static/spitz-video-cef7984e11f26f1436e297191b895e97.jpg";